require('./loanMovementsFiltersHeader.scss');

const PropTypes = require('prop-types');

//@ vendor
const React = require('react');
// @ utilities
const { recordLinkV2 } = require('utilities/tagging');
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { countActiveFilters, findActiveFilters } = require('utilities/filtersHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { commonCatalogueFilters, commonFilterAnalyticsId } = require('utilities/taggingCommonCatalogue');
// @components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { LabelFilterRange } = require('commonsComponents/labelFilterRange');
const { ClearAllFiltersButton } = require('commonsComponents/clearAllFiltersButton');
// @constants
const { DATE_FILTER_NONE, EURO_TEXT } = require('constants/index');
const { DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT, CLEAR_ALL_FILTERS_BUTTON_LABEL } = require('constants/commonsComponents');

class LoanMovementsFiltersHeader extends React.Component {

    buildFilterDateLabel() {
        const { immFilter, onResetFilter } = this.props;
        const immFilterDate = immFilter.get('date');

        if (findActiveFilters(immFilter) && immFilterDate.get('selected') !== DATE_FILTER_NONE && immFilterDate.get('from') && immFilterDate.get('to')) {
            const labelFromDate = immFilterDate.get('from').locale(DATE_PICKER_CUSTOM_LOCALE).format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));
            const labelToDate = immFilterDate.get('to').locale(DATE_PICKER_CUSTOM_LOCALE).format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));

            return (
                <LabelFilterRange
                    key="filter-date"
                    from={labelFromDate}
                    to={labelToDate}
                    closeCallback={() => {
                        recordLinkV2(commonCatalogueFilters[commonFilterAnalyticsId.RESET_FILTER]());
                        onResetFilter('date');
                    }}
                />
            );
        }
    }

    buildFilterAmountLabel() {
        const { immFilter, onResetFilter } = this.props;
        const immFilterAmount = immFilter.get('amount');
        const labelFromAmount = immFilterAmount.getIn(['from', 'amount']);
        const labelToAmount = immFilterAmount.getIn(['to', 'amount']);
        const language = getLanguage();

        if (findActiveFilters(immFilter) && (immFilterAmount.get('from') || immFilterAmount.get('to')) && (labelFromAmount !== null || labelToAmount !== null)) {
            let fromElem, toElem;

            if (labelToAmount !== undefined || labelFromAmount !== undefined && labelFromAmount <= labelToAmount) {

                if (labelFromAmount) {
                    const plainAmountObject = getPlainAmountObject({ amount: labelFromAmount, currency: EURO_TEXT });

                    fromElem = (
                        <span>
                            <FormattedText value="filters-min" />
                            <OneLineSymbolAmount
                                amountObject={plainAmountObject}
                                className="account-last-movements-content-filters__right-side-value"
                                language={language}
                                amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                        </span>
                    );
                }

                if (labelToAmount) {
                    const plainAmountObject = getPlainAmountObject({ amount: labelToAmount, currency: EURO_TEXT });

                    toElem = (
                        <span>
                            <FormattedText value="filters-max" />
                            <OneLineSymbolAmount
                                amountObject={plainAmountObject}
                                className="account-last-movements-content-filters__right-side-value"
                                language={language}
                                amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                        </span>
                    );
                }

                return (
                    <LabelFilterRange
                        key="filter-amount"
                        from={fromElem}
                        to={toElem}
                        closeCallback={() => {
                            onResetFilter('amount');
                        }}
                    />
                );
            }
        }
    }

    buildClearAllFilters() {
        const { immFilter, onClearFilters } = this.props;
        const countFilters = countActiveFilters(immFilter);
        let labelElement;
        if (countFilters > 1) {
            labelElement = (
                <ClearAllFiltersButton label={CLEAR_ALL_FILTERS_BUTTON_LABEL} onClick={onClearFilters} />
            );
        }
        return labelElement;
    }

    render() {
        const dateLabel = this.buildFilterDateLabel();
        const amountLabel = this.buildFilterAmountLabel();
        const clearAllFilters = this.buildClearAllFilters();

        return (
            <header className="loan-movements-filters-header">
                <div className="loan-movements-filters-header__labels">
                    {dateLabel}
                    {amountLabel}
                    {clearAllFilters}
                </div>
            </header>
        );
    }
}

LoanMovementsFiltersHeader.propTypes = {
    immFilter: PropTypes.object.isRequired,
    onClearFilters: PropTypes.func.isRequired,
    onResetFilter: PropTypes.func.isRequired,
};

module.exports = LoanMovementsFiltersHeader;
